module.exports = __webpack_public_path__ + "static/media/html5.c83aaf39.svg";